// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import $ from 'jquery';

import App from './App.jsx';

import {gen_snum, nameConversion, can_show_area, sep_mil, is_year} from './utils.js';

import './css/Dbf.css';



export type T_Dbf = {
  path   : string,
  recs   : {[string]: string | number},
  convs? : {[string]: string},
  is_mav?: boolean
};



type T_DbfProps = {
  dbf         : T_Dbf,
  dbf_hl      : ?string,
  num_decimals: number,
  app         : App
};



type T_State = {
  width: number
};



export default class Dbf extends Component<T_DbfProps, T_State> {
  state = {
    width: 100
  };
  
  
  
  fix_width(): void {
    const width = $('.tableDbf tr:first').width() + 2;
    
    this.setState({width});
    
    this.props.app.map_ui.setState({dbf_width: width});
  }
  
  
  
  componentDidMount() {
    this.fix_width();
  }
  
  
  
  labelize = (ev: SyntheticInputEvent<*>): void => {
    const key   = ev.target.dataset.name,
          {map} = this.props.app.map_ui;

    this.props.app.map_ui.setState({dbf_hl: this.props.dbf_hl === key ? null : key}, () => {
      const shp = map.Shp_List[this.props.dbf.path];

      if (shp != null) {
        _.keys(map.Shp_List).forEach((path) => {
          map.Shp_List[path].un_labelize();
        });

        shp.labelize(this.props.dbf_hl);
      }
    });
  }
  
  
  
  componentDidUpdate(prevProps: T_DbfProps, prevState: T_State) {
    if (this.state.width === prevState.width)
      return;
    
    this.fix_width();
  }
  
  
  
  render() {
    const WIDTH    = {width: this.state.width, maxWidth: this.state.width},
          snum     = gen_snum(this.props.num_decimals),
          is_coopr = _.startsWith(this.props.dbf.path, '/MAPS/Cooprinsem_CSP/'),
          is_crop  = is_coopr && this.props.dbf.path.indexOf('cropsense') !== -1,
          is_prod  = _.startsWith(this.props.dbf.path, '/MAPS/Cooprinsem/') && this.props.dbf.path.indexOf('/productividad/') !== -1,
          show_num = (val: number, key: string): string => {
            if (is_prod && (key === 'COD_VARIED' || key === 'NUM_PLAN' || key === 'ANO_PLANT'))
              return `${val}`;
            
            return (key === 'CODIGO' ? `${val}` : (key === 'PROM_MS' ? sep_mil(val) : snum(val)));
          },
          show_str = (val: string, key: string): string => {
            if (key === 'X_DESCRIP') {
              const ss = val.split(' ');
              
              if (ss.length > 0 && is_year(ss[0]))
                return ss.slice(1).filter(_.identity).join(' ');
            }
            
            return val;
          };
    
    return (
      <div className='divDbf' style={WIDTH}>
        <table className='tableDbf' style={WIDTH}>
          <tbody>
            {_.map(this.props.dbf.recs, (val: number | string, key: string) => {
              if (key === 'COLOR' || (this.props.dbf.is_mav && (key === 'ZONA' || key === 'AREA' || key === 'DOSIS')))
                return;
              
              if (key === 'AREA' && ! can_show_area(this.props.dbf.path))
                return;
              
              if (is_crop && (key === 'ID' || key === 'COD_POTRER' || key === 'PERIMETRO'))
                return;

              if (key === 'REGION')
                return;
              
              const name = {'data-name': key};
              
              return (
                <tr key={key}>
                  <td>
                    <a style={{fontWeight: this.props.dbf_hl === key ? 'bold' : 'normal'}} {...name} onClick={this.labelize}>
                      {(is_crop && key === 'NOMBRE') ?
                        'Nombre potrero'
                       :
                        (this.props.dbf.convs != null && _.has(this.props.dbf.convs, key) ?
                          this.props.dbf.convs[key]
                        :
                          nameConversion(this.props.app, key, false))
                      }
                    </a>
                  </td>
                  <td>
                    {typeof val === 'number' && key !== 'ID' ?
                      show_num(val, key)
                    :
                      (val === 'NULL' ?
                        ''
                      :
                        show_str(typeof val === 'string' ? val : `${val}`, key))}
                  </td>
                </tr>);
              }
            )}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Dbf.jsx